<template lang="pug">
  div
    app-modal.modalModelo(
      @closeModal="$emit('closeModal')"
      titulo="Adicionar modelo"
      :width="1100"
    )
      template(slot="body")
        validation-observer(ref='validation' tag='form')
          .group(v-if="hasPermissaoNotificar || exibirTitulo || exibirDespachoReurb || exibirDespacho || exibirModeloRegistroImovel || exibirModeloJustificativa || exibirModeloExtratoSentenca || exibirModeloTituloReurb")
            p.required Selecione qual tipo de modelo deseja adicionar:
            validation-provider(rules="required", v-slot="{ errors }")
              el-radio.input(v-if="exibirDespacho" :label="1" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho
              el-radio.input(v-if="hasPermissaoNotificar" :label="2" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de notificação
              el-radio.input(v-if="exibirTitulo", :label="3" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo do título
              el-radio.input(v-if="exibirDespachoReurb && isMaranhao", :label="4" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho dinâmico
              el-radio.input(v-if="exibirDespachoReurb && !isMaranhao", :label="4" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho
              el-radio.input(v-if="exibirModeloRegistroImovel && !isMaranhao", :label="5" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de registro de imóvel
              el-radio.input(v-if="exibirDespachoVistoria", :label="6" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo app vistoria
              el-radio.input(v-if="exibirModeloJustificativa && (isMaranhao || isAmapa)", :label="7" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo justificativa
              el-radio.input(v-if="exibirModeloExtratoSentenca", :label="8" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo extrato de sentença dinâmico
              el-radio.input(v-if="exibirModeloTituloReurb", :label="9" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de Título Reurb
          .group(v-else)
            p Adicionar um modelo de despacho
          // Campos específicos para Modelo de Título Reurb
          template(v-if="modelo.tipoModelo === 9")
            div.campo-filtro-reurb
              div
                p.required Município:
                validation-provider(rules="required", v-slot="{ errors }")
                  el-select.full-width.input(
                    v-model="modelo.idMunicipio",
                    placeholder="Selecione o município",
                    filterable,
                    clearable,
                    :class="{'erro' : errors.length}",
                    @change="buscarReurbColetivos"
                  )
                    el-option(
                      v-for="municipio in municipios",
                      :key="municipio.id",
                      :label="municipio.nome",
                      :value="municipio.id"
                    )
                  span(v-if="errors.length").help.erro {{ errors[0] }}
              div.input-reurb
                p.required Reurb Coletivo:
                validation-provider(rules="required", v-slot="{ errors }")
                  el-select.full-width.input(
                    v-model="modelo.idReurbColetivo",
                    placeholder="Selecione o Reurb Coletivo",
                    filterable,
                    clearable,
                    :disabled="!modelo.idMunicipio",
                    :class="{'erro' : errors.length}"
                  )
                    el-option(
                      v-for="reurb in reurbColetivos",
                      :key="reurb.id",
                      :label="`${reurb.numeroProcesso} - ${reurb.nomeRazaoSocialInteressado}`",
                      :value="reurb.id"
                    )
                  span(v-if="errors.length").help.erro {{ errors[0] }}
              div
                p.required Tipo Reurb:
                validation-provider(rules="required", v-slot="{ errors }")
                  el-select.full-width.input(
                    v-model="modelo.tipoReurb",
                    placeholder="Selecione o tipo",
                    :class="{'erro' : errors.length}"
                  )
                    el-option(label="REURB S", value="REURB_S")
                    el-option(label="REURB E", value="REURB_E")
                  span(v-if="errors.length").help.erro {{ errors[0] }}
          // Campos padrão para todos os tipos de modelo (incluindo Reurb)
          template
            .group.mt-1
              p.required {{getLabelDescricaoTexto(modelo.tipoModelo)}}:
              validation-provider(rules="required", v-slot="{ errors }")
                el-input.input(v-model="modelo.descricaoTexto",:class="{'erro' : errors.length}")
            .group.mt-1
              div
                .flex
                  p.required {{getLabelTextoModelo(modelo.tipoModelo)}}:
                el-tooltip(
                  v-if="modelo.tipoModelo === 2 && !isMaranhao && !isAmapa && !isBahia && modelo.tipoModelo !== 6"
                  effect='dark',
                  placement='top',
                  class="tooltip"
                )
                  template(slot="content")
                    span Para criar um modelo com o nome do interessado, número do processo,<br>
                    span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                    li Processo nº &lt;numero_processo&gt;<br>
                    li Interessado &lt;nome_interessado&gt;<br>
                    li Município &lt;municipio&gt;<br>
                    li Data emissão &lt;data_emissao&gt; <br>
                    li Município emissor &lt;municipio_emissor&gt <br>
                    li Local emissão &lt;local_emissao&gt <br>
                    li Área georreferenciamento &lt;area_georreferenciamento&gt <br>
                    li Área &lt;area&gt <br>
                    li Perfil emissor &lt;perfil_emissor&gt <br>
                    li Nome do emissor &lt;nome_emissor&gt <br>
                    li Número da notificação &lt;numero_notificacao&gt <br>
                    li CPF do interessado  &lt;cpf_interessado&gt <br>
                    li RG do interessado  &lt;rg_interessado&gt <br>
                  i.el-icon-info.icon-info
                el-tooltip(
                  v-if="(modelo.tipoModelo === 4 || modelo.tipoModelo === 5) && !isAmapa && !isBahia"
                  effect='dark',
                  placement='top',
                  class="tooltip"
                )
                  template(slot="content")
                    span Para criar um modelo de despacho com o nome do interessado, número do processo,<br>
                    span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                    li Processo nº &lt;numero_processo&gt;<br>
                    li Interessado &lt;nome_interessado&gt;<br>
                    li Município &lt;municipio&gt;<br>
                    li Bairro &lt;bairro&gt; <br>
                    li Dia &lt;dia&gt <br>
                    li Mês &lt;mes&gt <br>
                    li Ano &lt;ano&gt <br>
                    li Município emissor &lt;municipio_emissor&gt <br>
                    li Área &lt;area_georreferenciamento&gt <br>
                    li Perfil emissor &lt;perfil_emissor&gt <br>
                    li Nome do emissor &lt;nome_emissor&gt <br>
                    li CPF do interessado  &lt;cpf_interessado&gt <br>
                    li RG do interessado  &lt;rg_interessado&gt <br>
                  i.el-icon-info.icon-info
                el-tooltip(
                  v-if="(isAmapa || isBahia) && modelo.tipoModelo === 4"
                  effect='dark',
                  placement='top',
                  class="tooltip"
                )
                  template(slot="content")
                    span Para criar um modelo de despacho com o nome do interessado, número do processo,<br>
                    span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                    li Processo nº &lt;numero_processo&gt;<br>
                    li Interessado &lt;nome_interessado&gt;<br>
                    li Município &lt;municipio&gt;<br>
                    li Bairro &lt;bairro&gt; <br>
                    li Dia &lt;dia&gt; <br>
                    li Mês &lt;mes&gt; <br>
                    li Ano &lt;ano&gt; <br>
                    li Município emissor &lt;municipio_emissor&gt; <br>
                    li Área &lt;area_georreferenciamento&gt; <br>
                    li Perfil emissor &lt;perfil_emissor&gt; <br>
                    li Nome do emissor &lt;nome_emissor&gt; <br>
                    li CPF do interessado &lt;cpf_interessado&gt; <br>
                    li RG do interessado &lt;rg_interessado&gt; <br>
                  i.el-icon-info.icon-info
                el-tooltip(
                  v-if="(isAmapa || isBahia ) && (modelo.tipoModelo === 2 || modelo.tipoModelo == 7)"
                  effect='dark',
                  placement='top',
                  class="tooltip"
                )
                  template(slot="content")
                    span Para criar um modelo de notificação com o nome do interessado, número do processo,<br>
                    span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                    li Processo nº &lt;numero_processo&gt;<br>
                    li Interessado &lt;nome_interessado&gt;<br>
                    li Município &lt;municipio&gt;<br>
                    li Bairro &lt;bairro&gt; <br>
                    li Dia &lt;dia&gt; <br>
                    li Mês &lt;mes&gt; <br>
                    li Ano &lt;ano&gt; <br>
                    li Município emissor &lt;municipio_emissor&gt; <br>
                    li Área &lt;area_georreferenciamento&gt; <br>
                    li Perfil emissor &lt;perfil_emissor&gt; <br>
                    li Nome do emissor &lt;nome_emissor&gt; <br>
                    li CPF do interessado &lt;cpf_interessado&gt; <br>
                    li RG do interessado &lt;rg_interessado&gt; <br>
                  i.el-icon-info.icon-info
                el-tooltip(
                  v-if="modelo.tipoModelo === 8"
                  effect='dark',
                  placement='top',
                  class="tooltip"
                )
                  template(slot="content")
                    span Para criar um modelo de extrato de sentença, utilize conforme exemplos abaixo:<br>
                    li Nº extrato de sentença &lt;numero_extrato_sentenca&gt;<br>
                    li Nº processo Interessado municipio &lt;numero_processo_nome_interessado_municipio&gt;<br>
                  i.el-icon-info.icon-info
                div
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-editor-texto(:value="modelo.textoModelo", @onTextChange="onTextChange",:class="{'erro' : errors.length}")
            div(v-if="modelo.tipoModelo === 9")
              .group.mt-1
                p.labelAssinatura Assinaturas:&nbsp
                app-anexo(
                  :files="imagensAssinaturas",
                  :id="'upload-assinaturas-modelo'",
                  :tipoExibir="'ANEXO_ANALISE'",
                  :fileType="['png', 'jpg', 'jpeg']",
                  :exibirDownload="false",
                  @uploadFile="uploadAssinatura",
                  @removeFile="removeAssinatura"
                )
      template(slot="footer")
        .flex-between
          el-button(@click="$emit('closeModal')") Cancelar &nbsp
            .fa.fa-times

          div
            el-button(
               v-if="modelo.tipoModelo === 9"
               :loading="loadingPrevisualizacao"
               :disabled="loadingPrevisualizacao"
               @click="preVisualizar()"
              ) Pré-visualizar &nbsp
              .fa.fa-eye(v-if="!loadingPrevisualizacao")

            salvar-modelo(v-model="saveModelo" @update:modelValue="saveModelo($event)")

            el-button(
              v-if="modelo.tipoModelo === 9"
              type="success"
              @click="saveModelo($event, true)"
            ) Finalizar &nbsp
              .fa.fa-check

    app-modal-visualizar-modelo(
      v-if="showModalVisualizarModelo"
      :modelo="{ ...modelo, tipoModelo: 'Modelo de Título Reurb', textoModelo: textoModeloPrevisualizacao, assinaturas: imagensAssinaturas }"
      titulo="Pré-visualização do Modelo",
      ativaBotaoVoltar="true"
      @closeModal="showModalVisualizarModelo = false"
    )

</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import SalvarModelo from './SalvarModelo.vue'
import AppModalVisualizarModelo from './AppModalVisualizarModelo.vue'
import { mapActions, mapGetters } from 'vuex'
const { hasPermissaoNotificar, cadastro, separatorByUnderscore, defaultModeloDespacho } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppModal,
    AppLabel,
    AppEditorTexto,
    AppAnexo,
    SalvarModelo,
    AppModalVisualizarModelo
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      modelo: {
        tipoModelo: this.tipoModeloSwitcher,
        descricaoTexto: '',
        textoModelo: '',
        idMunicipio: null,
        idReurbColetivo: null,
        tipoReurb: null
      },
      anexos: [],
      showUpload: true,
      errorsAnexo: [],
      municipios: [],
      reurbColetivos: [],
      imagensAssinaturas: [],
      showModalVisualizarModelo: false,
      textoModeloPrevisualizacao: '',
      loadingPrevisualizacao: false
    }
  },
  beforeMount () {
    this.modelo.tipoModelo = this.tipoModeloSwitcher
  },
  async mounted () {
    if (this.isMaranhao) {
      const municipiosData = await this.findMunicipiosByEstadoAtual()
      this.municipios = municipiosData || []
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    /**
     * <b> Retorna o id selecionado de cada radio button </b> </br>
     * 4 para despacho dinâmico </br>
     * 2 para notificação do interessado dinâmico </br>
     * 1 para despacho normal (antigo) </br>
     * @author Gabriel N.
     */
    tipoModeloSwitcher () {
      if (this.isMaranhao) {
        return this.isNotAllowed() && defaultModeloDespacho
      }
      return this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo)) ? 2 : defaultModeloDespacho
    },
    hasPermissaoNotificar () {
      if (this.isAmapa || this.isBahia) {
        return this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(this.usuario.perfilSelecionado.codigo)
      }
      return (this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo))) ||
        this.isMaranhao
    },
    exibirTitulo () {
      return cadastro.exibirModeloTitulo && cadastro.perfisModeloTitulo.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespachoReurb () {
      return cadastro.exibirModeloDespachoReurb && cadastro.perfisModeloDespachoReurb.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespachoVistoria () {
      return cadastro.exibirModeloDespachoVistoria && cadastro.perfisModeloDespachoVistoria.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirModeloRegistroImovel () {
      return cadastro.exibirModeloRegistroImovel && cadastro.perfisModeloRegistroImovel.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespacho () {
      return cadastro.exibirModeloDespacho
    },
    exibirModeloJustificativa () {
      return cadastro.exibirModeloJustificativa && cadastro.perfisModeloJustificativa.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirModeloExtratoSentenca () {
      return cadastro.exibirModeloExtratoSentenca && cadastro.perfisModeloExtratoSentenca.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirModeloTituloReurb () {
      return cadastro.exibirModeloTituloReurb && cadastro.perfisModeloTituloReurb.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  },

  methods: {
    ...mapActions({
      salvarModeloDespacho: 'modeloDespacho/salvarModeloDespacho',
      buscarReurbColetivosPorMunicipio: 'modeloDespacho/buscarReurbColetivosPorMunicipio',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      previsualizarModelo: 'modeloDespacho/previsualizarModelo'
    }),
    async buscarReurbColetivos () {
      this.modelo.idReurbColetivo = null

      if (this.modelo.idMunicipio) {
        try {
          const response = await this.buscarReurbColetivosPorMunicipio(this.modelo.idMunicipio)
          this.reurbColetivos = response || []
        } catch (error) {
          this.reurbColetivos = []
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar Reurb Coletivos')
        }
      } else {
        this.reurbColetivos = []
        this.modelo.idReurbColetivo = null
      }
    },
    onTextChange (value) {
      this.modelo.textoModelo = value
    },
    uploadAssinatura (file) {
      if (this.imagensAssinaturas.length < 6) {
        this.imagensAssinaturas.push({
          key: file.response,
          nome: file.name,
          tipo: {
            id: 343,
            codigo: 'ASSINATURA_SIMBOLICA'
          }
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'É permitido no máximo 6 assinaturas!')
      }
    },
    removeAssinatura (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const index = this.imagensAssinaturas.findIndex(a =>
            (a.id && a.id === documento.id) || (a.key && a.key === documento.key)
          )
          if (index > -1) {
            this.imagensAssinaturas.splice(index, 1)
          }
        },
        () => {}
      )
    },
    getLabelDescricaoTexto (tipo) {
      switch (tipo) {
        case 2:
          return 'Descrição da Notificação'
        case 3:
          return 'Descrição do Título'
        case 5:
          return 'Descrição do Registro de Imóvel'
        case 7:
          return 'Descrição Justificativa'
        case 8:
          return 'Descrição do Extrato de Sentença'
        case 9:
          return 'Descrição do Modelo de Título Reurb'
        default:
          return 'Descrição do Despacho'
      }
    },
    getLabelTextoModelo (tipo) {
      switch (tipo) {
        case 2:
          return 'Notificação'
        case 3:
          return 'Título'
        case 5:
          return 'Registro de Imóvel'
        case 7:
          return 'Justificativa'
        case 8:
          return 'Extrato de Sentença'
        case 9:
          return 'Modelo de Título Reurb'
        default:
          return 'Despacho'
      }
    },
    /**
     * Perfis que não podem ter o modelo de notificação (Notificação dinãmica)
     * @returns {boolean}
     * @author Gabriel N.
     */
    isNotAllowed () {
      return !(this.usuario.perfilSelecionado.codigo === 'GOVERNADOR' || this.usuario.perfilSelecionado.codigo === 'PRESIDENTE_GP')
    },
    async preVisualizar () {
      this.loadingPrevisualizacao = true
      try {
        const response = await this.previsualizarModelo({ modelo: this.modelo.textoModelo })
        this.textoModeloPrevisualizacao = response.modelo
        this.showModalVisualizarModelo = true
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao gerar pré-visualização do modelo')
      } finally {
        this.loadingPrevisualizacao = false
      }
    },
    async saveModelo ($event, finalizar = false) {
      if (await this.$refs.validation.validate() && $event) {
        const modeloEnvio = {
          ...this.modelo,
          assinaturas: this.imagensAssinaturas.length > 0 ? this.imagensAssinaturas : null,
          ...(this.modelo.tipoModelo === 9 && { situacao: finalizar ? 'FINALIZADO' : 'EM_ANDAMENTO' })
        }

        this.salvarModeloDespacho(modeloEnvio).then(() => {
          this.$emit('closeModal')
          this.$emit('updateAoAdicionar', { campoSimples: '' })
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Modelo salvo com sucesso!')
        }).catch(() => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Erro ao salvar o modelo')
        })
      }
    }
  }
}

</script>

<style scoped lang="scss">

.group p.required:after {
    color: red;
    content: " *";
}

.flex {
  display: flex;
  align-items: baseline;
}

.tooltip {
  margin-left: 5px;
  color: black;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

/deep/ .el-button span {
  display: flex;
  font-size: 16px;
}

.erro {
  border: solid 1px red;
  border-radius: 5px;
}

.labelAssinatura {
  font-family: sans-serif;
  font-size: 14px;
  margin: 10px 0;
  font-weight: bold;
  color: black;
}

.campo-filtro-reurb {
  display: flex;
  margin-top: 20px;
  gap: 30px;
}

.input-reurb {
  flex: 0 0 35%;
}

@media (max-width: 780px) {
  .modalModelo {
    position: fixed !important;
    width: 395px !important;
  }
  .input-reurb {
    flex: 1;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalAdicionarModelo.vue